import { getSupplierConfigNonReact } from 'pages/ordering/hooks/useGetSupplierConfig'
import { HardwareSupplierFilterKeyType } from 'pages/ordering/type'
import { useCallback, useEffect, useMemo, useState } from 'react'
import restClient from 'restClient'
import type { ComponentTypes } from '../../../types/selectComponent'

type LoadDistributorAvailableBrandsOptions = { distributor: HardwareSupplierFilterKeyType }

const useGetDistributorAvailableBrands = ({ componentType }: { componentType?: ComponentTypes }) => {
  const restClientInstance = restClient(window.API_ROOT + '/api')

  const getDistributorAvailableBrands = useCallback(
    async ({ distributor }: LoadDistributorAvailableBrandsOptions) => {
      const supplierConfig = getSupplierConfigNonReact(distributor)
      const response = await restClientInstance('CUSTOM_GET', 'custom', {
        url: `ordering/${supplierConfig?.filterKey}/manufacturer_list/?component_type=${componentType}`,
      })
      return response.data
    },
    [componentType]
  )

  return getDistributorAvailableBrands
}

const useDistributorAvailableBrands = ({
  distributor,
  componentType,
}: {
  distributor?: HardwareSupplierFilterKeyType
  componentType?: ComponentTypes
}) => {
  const [brands, setBrands] = useState<string[]>(() => [])
  const getDistributorAvailableBrands = useGetDistributorAvailableBrands({ componentType })
  useEffect(() => {
    if (distributor !== undefined) {
      getDistributorAvailableBrands({ distributor }).then((brands) => {
        if (brands && brands.length > 0) {
          setBrands(brands)
        }
      })
    }
  }, [componentType, distributor])
  return useMemo(() => brands, [componentType, brands])
}

export default useDistributorAvailableBrands
